import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { products } from '@/data/products';

export default function Products() {
  return (
    <div className="page-shell">
      <div className="max-w-3xl">
        <h1 className="section-heading">Our Products</h1>
        <p className="section-subheading">
          Purpose-built platforms we develop and operate — shaped by years of field marketing,
          trade sales, and consumer campaign experience across Malaysia.
        </p>
      </div>

      <div className="mt-12 space-y-16 sm:mt-16 sm:space-y-20">
        {products.map((product, index) => (
          <article
            key={product.id}
            id={product.id}
            className="scroll-mt-28 rounded-2xl border border-slate-200 bg-white shadow-sm"
          >
            <div className="border-b border-slate-100 px-6 py-8 sm:px-8 sm:py-10 lg:px-12">
              <p className="text-sm font-bold uppercase tracking-[0.18em] text-brand-600">
                Product {index + 1}
              </p>
              <h2 className="mt-2 text-3xl font-extrabold tracking-tight text-brand-900 sm:text-4xl">
                {product.name}
              </h2>
              <p className="mt-2 text-lg font-bold text-brand-700 sm:text-xl">{product.tagline}</p>
              <p className="mt-4 text-base font-semibold leading-relaxed text-slate-600 sm:text-lg">
                {product.pitch}
              </p>
              <p className="mt-4 text-base font-semibold leading-relaxed text-slate-600 sm:text-lg">
                {product.description}
              </p>
            </div>

            <div className="px-6 py-8 sm:px-8 sm:py-10 lg:px-12">
              <h3 className="text-xl font-bold text-brand-900 sm:text-2xl">Key capabilities</h3>
              <div className="mt-6 grid gap-5 sm:grid-cols-2 sm:gap-6">
                {product.features.map((feature) => (
                  <div
                    key={feature.title}
                    className="rounded-xl border border-slate-100 bg-slate-50/80 p-5 sm:p-6"
                  >
                    <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-brand-50 text-brand-600">
                      <feature.icon className="h-5 w-5" />
                    </div>
                    <h4 className="mt-4 text-lg font-bold text-brand-900">{feature.title}</h4>
                    <p className="mt-2 text-base font-semibold leading-relaxed text-slate-600">
                      {feature.description}
                    </p>
                  </div>
                ))}
              </div>

              <div className="mt-8 rounded-xl border border-brand-100 bg-brand-50 px-5 py-5 sm:px-6">
                <p className="text-sm font-bold uppercase tracking-wide text-brand-700">
                  Built for
                </p>
                <p className="mt-2 text-base font-semibold leading-relaxed text-slate-700 sm:text-lg">
                  {product.audience}
                </p>
              </div>
            </div>
          </article>
        ))}
      </div>

      <div className="mt-16 rounded-2xl border border-brand-100 bg-brand-50 px-5 py-8 sm:mt-20 sm:px-8 sm:py-10 lg:px-12">
        <h2 className="text-2xl font-extrabold text-brand-900 sm:text-3xl">
          Interested in a product demo?
        </h2>
        <p className="mt-3 max-w-2xl text-base font-semibold text-slate-600 sm:text-lg">
          Whether you need field sales management or consumer campaign engagement, we&apos;d be
          happy to walk you through how our platforms work and whether they fit your operation.
        </p>
        <Link to="/contact" className="btn-primary mt-6 inline-flex sm:w-auto">
          Request a conversation
          <ArrowRight className="ml-2 h-4 w-4" />
        </Link>
      </div>
    </div>
  );
}
